import React from 'react'
import _ from 'lodash'

import {Grid, Row, Col} from 'react-flexbox-grid'

import {OrganizationStore, OrganizationService} from 'api/organization'
import {NotFound} from 'pages/NotFound.jsx'

export class OrganizationsStorage extends React.Component {
   static get propTypes() {
      return {
         children: React.PropTypes.node.isRequired
      }
   }

   constructor() {
      super()
      this.state = {organizations: OrganizationStore.organizations}

      this._mounted = null
   }

   componentWillMount() {
      this._mounted = true

      OrganizationService.list()

      OrganizationStore.addChangeListener(
         (this._listener = () => {
            if (this._mounted) {
               this.setState({organizations: OrganizationStore.organizations})
            }
         }),
      )
   }

   componentWillUnmount() {
      this._mounted = false
      OrganizationStore.removeChangeListener(this._listener)
   }

   render() {
      let {organizations} = this.state,
         {children, ...props} = this.props

      return React.cloneElement(children, _.assign({}, props, {organizations: organizations}))
   }
}

export class OrganizationStorage extends React.Component {
   static get propTypes() {
      return {
         children: React.PropTypes.node.isRequired,
         nid:      React.PropTypes.string,
         sidebar:  React.PropTypes.any
      }
   }

   constructor(props) {
      super(props)
      this.state = {organization: OrganizationStore.organization(props.nid)}
   }

   componentWillMount() {
      let organization = null

      this._mounted = true

      organization = OrganizationStore.organization(this.props.nid)

      if (!organization && this.props.nid) {
         OrganizationService.fetch(this.props.nid)
      }

      OrganizationStore.addChangeListener(
         (this._listener = () => {
            organization = OrganizationStore.organization(this.props.nid)

            if (this._mounted) {
               this.setState({organization})
            }
         }),
      )
   }

   componentWillUnmount() {
      this._mounted = false
      OrganizationStore.removeChangeListener(this._listener)
   }

   componentWillReceiveProps(next) {
      let organization = null

      if (next.nid !== this.props.nid) {
         organization = OrganizationStore.organization(next.nid)

         if (!organization && next.nid) {
            OrganizationService.fetch(next.nid)
         }

         this.setState({organization: organization})
      }
   }

   render() {
      let {organization} = this.state,
         {children, sidebar, ...props} = this.props,
         hasSidebar = _.isFunction(sidebar)

      if (organization) {
         return React.cloneElement(children, _.assign({}, props, {organization: organization}))
      } else {
         return (
            <Grid>
               <Row style={{padding: '2rem 0'}}>
                  {hasSidebar &&
                     <Col className="sidebar" xs={4}>
                        {sidebar()}
                     </Col>}

                  <Col className="main" xs={hasSidebar ? 8 : 12}>
                     <NotFound />
                  </Col>
               </Row>
            </Grid>
         )
      }
   }
}



// WEBPACK FOOTER //
// lib/storage/Organization.jsx